export  class PrintCCReceiptModel
{
  PatientID: string;
  LedgerID: string;
  PaymentID: string;
  EnterpriseID: string;
  LOCID: string;
  TDOCID: string;
}